// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrophyOutlinedSvg from "@ant-design/icons-svg/es/asn/TrophyOutlined";
import AntdIcon from '../components/AntdIcon';

var TrophyOutlined = function TrophyOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrophyOutlinedSvg
  }));
};

TrophyOutlined.displayName = 'TrophyOutlined';
export default React.forwardRef(TrophyOutlined);